/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_TitleInputs */

const en_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Event Group`)
};

const fr_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier le groupe d'événements`)
};

const de_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe bearbeiten`)
};

const it_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica gruppo eventi`)
};

const ru_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать группу событий`)
};

const es_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar grupo de eventos`)
};

const zh_cn2_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑事件组`)
};

const ja_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを編集`)
};

const hi_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह संपादित करें`)
};

const pt_pt2_edit_event_group_title = /** @type {(inputs: Edit_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Edit Event Group" |
*
* @param {Edit_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_title = /** @type {((inputs?: Edit_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_title(inputs)
	if (locale === "de") return de_edit_event_group_title(inputs)
	if (locale === "it") return it_edit_event_group_title(inputs)
	if (locale === "ru") return ru_edit_event_group_title(inputs)
	if (locale === "es") return es_edit_event_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_title(inputs)
	if (locale === "ja") return ja_edit_event_group_title(inputs)
	if (locale === "hi") return hi_edit_event_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_title(inputs)
	return en_edit_event_group_title(inputs)
});